import { Route, Routes } from 'react-router-dom';

import DetailPage from 'pages/detail';
import EditPage from 'pages/edit';
import LoginPage from 'pages/login';
import NotFound from 'pages/notFound';
import SavePage from 'pages/save';
import SearchPage from 'pages/search';

import PrivateRoute from './privateRoute';

const AppRoutes = () => {
  return (
    <Routes>
      <Route exact path="/" element={<SearchPage />} />
      <Route path="/login" element={<LoginPage />} />

      <Route
        path="/Novo/:tipoDoc"
        element={
          <PrivateRoute>
            <SavePage />
          </PrivateRoute>
        }
      />

      <Route
        path="/:tipoDoc/Editar/:id"
        element={
          <PrivateRoute>
            <EditPage />
          </PrivateRoute>
        }
      />

      <Route
        path="/:tipoDoc/Detalhe/:id"
        element={<DetailPage />}
      />

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
